module.exports = __webpack_public_path__ + "img/blog5.5356a494.jpg";